import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Uttam Diabetes Clinic</h3>
          <p>Your trusted partner in diabetes care and treatment.</p>
          <div className="footer-social">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
          </div>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/kill-diabetes">Kill Diabetes</Link></li>
            <li><Link to="/our-centers">Our Centers</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Contact Info</h3>
          <ul>
            <li><i className="fas fa-map-marker-alt"></i> Patna-Muzaffarpur-Motihari-Siwan-Gopalganj-Purnia-Bhagalpur-Farbisganj-Kusinagar-Darbhanga</li>
            <li><i className="fas fa-phone-alt"></i> +91 9939765562</li>
            <li><i className="fas fa-envelope"></i> info@drsantoshkumar.co.in</li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Services</h3>
          <ul>
            <li><Link to="/kill-diabetes">Diabetes Treatment</Link></li>
            <li><Link to="/kill-diabetes">Kidney Care</Link></li>
            <li><Link to="/kill-diabetes">Creatinine Management</Link></li>
            <li><Link to="/kill-diabetes">Sugar Control</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2026 Uttam Diabetes Clinic & Research Center. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;